/**
 * Brand configuration — switches between amazonico3000.com (full app) and mzn300.com (B2C only).
 * Controlled via env var REACT_APP_SITE_BRAND ("amazonico" default | "mzn300").
 */
const BRAND = (process.env.REACT_APP_SITE_BRAND || "amazonico").toLowerCase();

// External URL where the B2C storefront lives (mzn300.com).
// On amazonico3000.com the B2C nav/CTA links point HERE instead of internal /b2c.
export const B2C_EXTERNAL_URL =
  process.env.REACT_APP_B2C_URL || "https://mzn300.com";

// Amazonico3000.com URL used from mzn300.com when linking back to the B2B ecosystem.
export const B2B_EXTERNAL_URL =
  process.env.REACT_APP_B2B_URL || "https://amazonico3000.com";

export const BRAND_CONFIG = {
  amazonico: {
    key: "amazonico",
    name: "Amazonico 3000",
    tagline: "ExportTech · Italia → Mondo",
    logoNav: "/amazonico-logo.png",
    logoFooter: "/amazonico-logo.png",
    // On amazonico3000.com "/" shows the Splash gate that lets user choose.
    defaultRoute: "/",
    // B2C link on amazonico3000.com is now EXTERNAL to mzn300.com
    b2cLinkExternal: true,
    b2cUrl: B2C_EXTERNAL_URL,
    // Full nav: show B2B menu
    showB2BNav: true,
    accentHex: "#C9A961",
    palette: "gold",
  },
  mzn300: {
    key: "mzn300",
    name: "MZN 300",
    tagline: "Vino · Cucina · Cultura italiana",
    logoNav: "/mzn300-logo.png",
    logoFooter: "/mzn300-logo-full.png",
    // On mzn300.com "/" shows B2C storefront directly (no splash gate)
    defaultRoute: "/",
    b2cLinkExternal: false,
    b2cUrl: "/",
    // Hide B2B/Gestionale menu on the B2C-only brand
    showB2BNav: false,
    accentHex: "#7A1C2B",
    palette: "burgundy",
  },
};

export const CURRENT_BRAND = BRAND_CONFIG[BRAND] || BRAND_CONFIG.amazonico;
export const IS_MZN300 = BRAND === "mzn300";
export const IS_AMAZONICO = !IS_MZN300;

/**
 * Returns the correct destination for a "B2C" CTA depending on the current brand.
 * On amazonico3000.com → https://mzn300.com (external, new tab)
 * On mzn300.com → "/" (internal, same tab — already the storefront home)
 */
export function b2cHref() {
  return CURRENT_BRAND.b2cLinkExternal ? CURRENT_BRAND.b2cUrl : "/";
}

export function b2cLinkProps(extra = {}) {
  if (CURRENT_BRAND.b2cLinkExternal) {
    return {
      href: CURRENT_BRAND.b2cUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      ...extra,
    };
  }
  return { href: "/", ...extra };
}
